export default "__VITE_ASSET__29d1ec9f__$_?component__"